import { Component, OnInit, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { Page } from 'src/app/models/page.model';
import { Subscription, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { PopoverController, IonSelect } from '@ionic/angular';
import { SearchpopoverComponent } from 'src/app/shared/components/searchpopover/searchpopover.component';

@Component({
  selector: 'app-permissions',
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './permissions.page.html',
  styleUrls: ['./permissions.page.scss'],
})
export class PermissionsPage implements OnInit {

  @ViewChild('table') table: DatatableComponent;
  @ViewChild('IonSelect') select: IonSelect;

  rows = [];
  UserRoleId: string;
  Roles: any = [];

  checkboxChanged = false;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  page = new Page();

  showPage: boolean = false;
  loaded: boolean = false;

  constructor(private router: Router, private _apiService: ApiService, public _commonService: CommonService, private popoverController: PopoverController, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.page.orderDir = 'desc';
    this.getRoles();
    this.rows = [];
    this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
      setTimeout( () => {
        this.rows = [...this.rows];
        this.table.recalculate();
      },0)
    });
    this.resizeSubscription = this._commonService.onResize.subscribe(event => {
    });
  }

  ionViewDidLeave(){
    if(this.toggleSubscription){
      this.toggleSubscription.unsubscribe();
    }
    if (this.resizeSubscription) this.resizeSubscription.unsubscribe();
  }

  async getPermissions(roleId, showLoading) {
    try {
      if (showLoading){
        this._commonService.presentLoading();
      }
      let data = await this._apiService.getPermissions('', roleId);
      this.rows = data.body;
      if (showLoading) {
        this._commonService.dismiss();
      }
      this._commonService.log(this.rows, this._commonService.LOG);
      this.checkboxChanged = false;
      let checkboxChanged = document.getElementById('checkboxChanged');
      if (checkboxChanged){
        checkboxChanged.setAttribute('style', 'position: absolute; left: 0; top: 0;width:100%;height:100%;background: transparent;z-index: 100;display:none;');
        this.cdr.detectChanges();
      }
    } catch (error) {
      if (showLoading) {
        this._commonService.dismiss();
      }
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getRoles() {
    try {
      this._commonService.presentLoading();
      if (localStorage.userRoles) {
        this.Roles = JSON.parse(localStorage.userRoles);
      }else{
        let roleData = await this._apiService.getUserRoles('', 1, 0);
        localStorage.setItem('userRoles', JSON.stringify(roleData.body));
        this.Roles = roleData.body;
      }
      if(localStorage.roleCode === 'UserRole_Moderator'){
        let mod = this.Roles.find(x => x.UserRoleCode == 'UserRole_Moderator');
        if(mod){
          this.UserRoleId = mod.UserRoleId;
        }
        this.Roles = this.Roles.filter( user => user.UserRoleCode != "UserRole_Administrator" );
      }else{
        let admin = this.Roles.find(x => x.UserRoleCode == 'UserRole_Administrator');
        if(admin){
          this.UserRoleId = admin.UserRoleId;
        }
      }
      await this.getPermissions(this.UserRoleId, false);
      this.loaded = true;
      this._commonService.dismiss();
      this._commonService.log(this.Roles, this._commonService.LOG);
      setTimeout( () => {
        this.showPage = true;
      }, 0 )
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  checkForCheckBoxChecked(event){
    if (this.checkboxChanged) {
      this._commonService.presentMessageConfirmation("", this._commonService.getLocalTranslation('label-discardChanges'))
      .then( () => {
        this.checkboxChanged = false;
        let checkboxChanged = document.getElementById('checkboxChanged');
        checkboxChanged.setAttribute('style', 'position: absolute; left: 0; top: 0;width:100%;height:100%;background: transparent;z-index: 100;display:none;');
        this.cdr.detectChanges();
        this.select.open();
      } )
      .catch( (error) => {
      } )
    } else {
      return;
    }
  }

  async roleChange(){
    this.loaded = false;
    await this.getPermissions(this.UserRoleId, true);
    this.loaded = true;
    this.table.sorts = [];
  }

  goBack() {
    this._commonService.goBack('maintenance');
  }

  async onSubmit(){
    this._commonService.presentLoading();
    try {
      this._commonService.log(this.rows, this._commonService.LOG);
      await this._apiService.postPermissions(this.rows);
      this._commonService.dismiss();
      let checkboxChanged = document.getElementById('checkboxChanged');
      checkboxChanged.setAttribute('style', 'position: absolute; left: 0; top: 0;width:100%;height:100%;background: transparent;z-index: 100;display:none;');
      this.cdr.detectChanges();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      // this._commonService.goBack('maintenance');
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  updateValue(event, cell, rowIndex) {
    event.cancelBubble = true;
    if (this.loaded){
      if (event.detail) {
        this.checkboxChanged = true;
        let checkboxChanged = document.getElementById('checkboxChanged');
        checkboxChanged.setAttribute('style', 'position: absolute; left: 0; top: 0;width:100%;height:100%;background: transparent;z-index: 100;display:block;');
        this.cdr.detectChanges();
        this.rows[rowIndex][cell] = event.detail.checked ? 1 : 0;
        let item = this.rows[rowIndex].AccessLabel;
        // check for permissions dependencies and update them
        if (item == "Objects" && cell == "CanRead"){
          let folder = this.rows.findIndex((p) => p.AccessLabel == "Folders");
          if (folder != -1 && event.detail.checked) this.rows[folder][cell] = 1;

          let objecttype = this.rows.findIndex((p) => p.AccessLabel == "ObjectTypes");
          if (objecttype != -1 && event.detail.checked) this.rows[objecttype][cell] = 1;

          let objectgroup = this.rows.findIndex((p) => p.AccessLabel == "ObjectGroups");
          if (objectgroup != -1 && event.detail.checked) this.rows[objectgroup][cell] = 1;
        }
        if (item == "ObjectFolders" && cell == "CanRead"){
          let interval = this.rows.findIndex((p) => p.AccessLabel == "ScheduleIntervals");
          if (interval != -1 && event.detail.checked) this.rows[interval][cell] = 1;
        }
        if (item == "Users" && cell == "CanRead"){
          let userroles = this.rows.findIndex((p) => p.AccessLabel == "UserRoles");
          if (userroles != -1 && event.detail.checked) this.rows[userroles][cell] = 1;

          let objectgroup = this.rows.findIndex((p) => p.AccessLabel == "ObjectGroups");
          if (objectgroup != -1 && event.detail.checked) this.rows[objectgroup][cell] = 1;
        }
        if (item == "Companies" && cell == "CanRead"){
          let users = this.rows.findIndex((p) => p.AccessLabel == "Users");
          if (users != -1 && event.detail.checked) this.rows[users][cell] = 1;

          let objectgroup = this.rows.findIndex((p) => p.AccessLabel == "ObjectGroups");
          if (objectgroup != -1 && event.detail.checked) this.rows[objectgroup][cell] = 1;
        }
        if (item == "Activity list" && cell == "CanRead"){
          let objectgroup = this.rows.findIndex((p) => p.AccessLabel == "ObjectGroups");
          if (objectgroup != -1 && event.detail.checked) this.rows[objectgroup][cell] = 1;

          let objects = this.rows.findIndex((p) => p.AccessLabel == "Objects");
          if (objects != -1 && event.detail.checked) this.rows[objects][cell] = 1;

          let folder = this.rows.findIndex((p) => p.AccessLabel == "Folders");
          if (folder != -1 && event.detail.checked) this.rows[folder][cell] = 1;
        }
        this.rows = [...this.rows];
      }
    }
  }

  toNumber(text){
    return Number(text)
  }

  onSort(event){
    this.loaded = false;
    if (event.sorts[0].dir === 'asc'){
      this.rows = [...this.rows.sort((a, b) => {
        let alc = a.Name.toLowerCase(), blc = b.Name.toLowerCase();
        return this._commonService.sortAsc(alc, blc);
      })];
    }else{
      this.rows = [...this.rows.sort( (a, b) => {
        let alc = a.Name.toLowerCase(), blc = b.Name.toLowerCase();
        return this._commonService.sortDesc(alc, blc);
      })];
    }
    setTimeout( () => {
      this.loaded = true;
    },100 )
  }

}
